import { type Document, Document as MyAdvocateDocument } from 'types/zod/document';

const DocumentsService = {
    isSignable: (document: Document) => {
        return !['Diagram', 'Diagram_Spouse', 'SI_Will', 'SI_Spouse_Will'].includes(document.document_type_code);
    },

    getShortName: (document: MyAdvocateDocument) => {
        if (
            ['SI_Trust', 'SI_Trust_Joint', 'SI_Trust_Spouse'].includes(document.document_type_code) &&
            document.name.indexOf(' -') > -1
        ) {
            return document.name.substring(0, document.name.indexOf(' -'));
        }
        return document.name;
    },
};

export default DocumentsService;
